export default "__VITE_ASSET__B3_wur6S__"